import React from 'react'
import { MilestoneTable } from '.'
import { Plus } from 'react-feather'
import { Link } from 'react-router-dom'

const ContentOfficialMilestones = () => {
  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <p className="text-lg font-bold">Milestones</p>
        <Link
          to="/dashboard/profile/milestones/edit"
          className="text-sm text-primary flex items-center cursor-pointer"
        >
          <Plus className="mr-1" style={{width: '16px'}}/>
          <p>Add <span className="hidden lg:inline">New Milestone</span></p>
        </Link>
      </div>
      <div className="mobile-fullwidth">
        <MilestoneTable />
      </div>
    </div>
  )
}

export { ContentOfficialMilestones }